import {ajax,getRequestUrl} from "../request";

export default {
  // 群组管理 -- 群聊列表
  groupList(data) {
    return ajax('post', getRequestUrl('/api/Message/groupList'), data)
  },
}



// WEBPACK FOOTER //
// ./src/js/https/group.js